import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-415786ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "message-detail"
}
const _hoisted_2 = {
  key: 0,
  class: "message-meta"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaggedText = _resolveComponent("TaggedText")!

  return (_openBlock(), _createElementBlock("article", {
    class: "detail message",
    style: _normalizeStyle({ minHeight: _ctx.heightPercentagePx(0.8) })
  }, [
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          (_ctx.message.from || _ctx.message.to)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                (_ctx.message.from)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Melati van " + _toDisplayString(_ctx.message.from) + " ", 1),
                      _hoisted_3
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.message.to)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" voor " + _toDisplayString(_ctx.message.to), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_TaggedText, {
            tag: _ctx.first ? 'h1' : 'h2',
            text: _ctx.message.title,
            tags: _ctx.message.tags
          }, null, 8, ["tag", "text", "tags"]),
          (_ctx.message.text)
            ? (_openBlock(), _createBlock(_component_TaggedText, {
                key: 1,
                class: "text",
                text: _ctx.message.text,
                tags: _ctx.message.tags
              }, null, 8, ["text", "tags"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 4))
}